import { configureStore } from '@reduxjs/toolkit'
import authReducer from "./slices/auth";
import messageReducer from "./slices/message";
import userReducer from "./slices/user";
import organizationsReducer from "./slices/organization"
import OrchestratorReducer from "slices/orchestrator"
import BloxReducer from "slices/blox"
import UtilityReducer from "slices/utility"
import JobsReducer from "slices/job"
import SchedulesReducer from "slices/schedule"
import WorkflowContributionsReducer from "slices/workflow_contribution"
import workflowsReducer from "slices/workflow"
import WorkflowStepsReducer from "slices/workflow_step"
import workflowUiReducer from "slices/workflowUI"
import StateSetReducer from "slices/state"
import CustomerNetworkReducer from "slices/customer_network"
import ContributorReducer from "slices/contributor"
import TeamReducer from "slices/team"
import GroupReducer from "slices/group"
import CustomerDefaultsReducer from "slices/customer_defaults"
import tablePageReducer from "slices/tablePage"
import KpiReducer from "slices/kpi"
import ServiceReducer from 'slices/services';
import DashboardReducer from 'slices/dashboard';
import DimensionReducer from 'slices/dimensions';
import OpportunityReducer from 'slices/opportunity';
import CloudOrgStructureReducer from 'slices/cloudOrgStructure'
import AuditLogReducer from 'slices/auditLog';
import SequenceReducer from 'slices/sequence';
import CopilotReducer from 'slices/copilot';
import CatalogueReducer from 'slices/catalogue';
import SearchReducer from 'slices/search';
import ConfigReducer from 'slices/config';
import BackupReducer from 'slices/backup';
import AttachmentReducer from 'slices/attachment';
import MasterDataActionLogReducer from 'slices/masterDataActionLog';

import PreferenceReducer from 'slices/preference';
import UtilityFieldConfigReducer from 'slices/utilityFieldConfig';

const reducer = {
  auth: authReducer,
  message: messageReducer,
  users: userReducer,
  organizations: organizationsReducer,
  orchestrators: OrchestratorReducer,
  blox: BloxReducer,
  utility: UtilityReducer,
  job: JobsReducer,
  schedules: SchedulesReducer,
  workflowContributions: WorkflowContributionsReducer,
  workflows : workflowsReducer,
  workflowSteps: WorkflowStepsReducer,
  workflowUi: workflowUiReducer,
  stateSet: StateSetReducer,
  customerNetwork: CustomerNetworkReducer,
  contributor: ContributorReducer,
  team: TeamReducer,
  group: GroupReducer,
  customerDefaults: CustomerDefaultsReducer,
  tablePage: tablePageReducer,
  kpi: KpiReducer,
  services : ServiceReducer,
  dashboards : DashboardReducer,
  dimensions : DimensionReducer,
  opportunity: OpportunityReducer,
  cloudOrgStructure: CloudOrgStructureReducer,
  auditLog: AuditLogReducer,
  sequence: SequenceReducer,
  copilot: CopilotReducer,
  catalogue : CatalogueReducer,
  search: SearchReducer,
  config: ConfigReducer,
  backup: BackupReducer,
  attachment: AttachmentReducer,
  masterDataActionLog: MasterDataActionLogReducer,
  preference: PreferenceReducer,
  utilityFieldConfig: UtilityFieldConfigReducer,
}


const store = configureStore({
  reducer: reducer,
  devTools: process.env.NODE_ENV !== 'production',
})

export default store;